export const SITE = {
  name: "SparkGrid Solutions",
  tagline: "Innovating Beyond Limits",
  whatsapp: "918828545555",
  phoneDisplay: "+91 88285 45555",
  phoneHref: "tel:+918828545555",
  email: "connect@sparkgrid.io",
  address:
    "11/03, Rashmi Tanmay, I-Wing CHS Ltd, Eden Roase, Beverly Park Road, Opp. Cinemax, Mira Road East, Mira Bhayandar, Thane, Maharashtra 401107",
  mapQuery: "Rashmi Tanmay Beverly Park Mira Road East Thane 401107",
  addressShort: "Mumbai, Maharashtra, India",
  hours: "Mon – Sat, 10:00 AM – 7:00 PM IST",
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_7ac79f94-af08-46ca-a9a8-2e0b02069eee/artifacts/tmm8xyds_image.png",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;
